function Layout({ nameClass, children }) {
  return <div className={nameClass}>{children}</div>;
}

export default Layout;
